module.exports = __webpack_public_path__ + "img/tickets.ce921178.jpg";